import { render, staticRenderFns } from "./CommandEmpty.vue?vue&type=template&id=89e35b16"
import script from "./CommandEmpty.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommandEmpty.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports